import React from "react";
import { Link } from "react-router-dom";
import { PageHeader } from "../components/PageHeader";
import { Calendar, ArrowUpRight } from "lucide-react";
import { newsItems } from "../lib/content";

export default function Haberler() {
  return (
    <>
      <PageHeader
        eyebrow="Güncel"
        title="Haberler"
        description="Döviz ve altın piyasalarından son gelişmeler ve uzman analizleri."
      />
      <section className="py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="grid md:grid-cols-2 gap-6">
            {newsItems.map((n) => (
              <Link
                key={n.slug}
                to={`/haberler/${n.slug}`}
                className="group bg-white border border-slate-200 rounded-2xl overflow-hidden hover:border-slate-950 hover:shadow-xl transition-all block"
                data-testid={`news-card-${n.slug}`}
              >
                <div className="relative aspect-[16/9] overflow-hidden bg-slate-100">
                  <img
                    src={n.image}
                    alt={n.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                  <span className="absolute top-4 left-4 px-3 py-1 rounded-full bg-white/95 text-[10px] uppercase tracking-[0.2em] font-bold text-slate-950">
                    {n.cat}
                  </span>
                </div>
                <div className="p-7">
                  <div className="flex items-center gap-2 text-xs text-slate-500 mb-3">
                    <Calendar className="w-3.5 h-3.5" />
                    {n.date}
                  </div>
                  <h3 className="font-display text-xl md:text-2xl font-bold text-slate-950 mb-3 leading-tight group-hover:text-brand-gold transition-colors">
                    {n.title}
                  </h3>
                  <p className="text-sm text-slate-600 leading-relaxed mb-4">{n.desc}</p>
                  <div className="inline-flex items-center gap-1.5 text-sm font-semibold text-slate-950 group-hover:text-brand-gold transition-colors">
                    Devamını Oku
                    <ArrowUpRight className="w-4 h-4 group-hover:rotate-45 transition-transform" />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
